module.exports = " <div _v-1e9253b0=\"\"> <a href=# class=\"fa fa-upload\" title=\"Загрузить из Shapefile (ZIP), KML, KMZ\" @click.stop=selectFile _v-1e9253b0=\"\"></a> <input type=file name=shapefile ref=shapefile @change=uploadFile accept=application/zip,.kml,.kmz _v-1e9253b0=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1e9253b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShapeFileUploader.vue
// module id = 215
// module chunks = 0